module.exports = __webpack_public_path__ + "img/yszc-qm.b38c100d.png";